import React, { Component } from 'react';
import { PushButton } from './components';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { OUTPUT_TTL } from '../../constants/Pac';

@inject('batchStore')
@observer
class Boot extends Component {

  render() {
    const { device, batchStore } = this.props;
    const active = batchStore.isOutputOn(device.upPNo) ? 'active' : '';
    const s = batchStore.isInputPortOff(device.downStatusPNo);
    const status = !s ? 'ON' : 'OFF';
    // DOWN STATUS P NO: 1= (Allow system to discharge) 0= (don't allow system  to discharge ICON will turn RED)
    const name = device.description || 'Boot';

    return (
      <div id={`device-${device.id}`} className={`${active} down-status-${status} device-gui device-gui--boot device-icon-${device.icon}`}>
        <div className="device-label">
          <div className="device-type" title={`#${device.id}`}>{name}</div>
        </div>
        <div className="device-icon body"/>
        <div className="device-buttons">
          <PushButton port={device.upPNo}
            onPush={() => {
              batchStore.setOutput(device.upPNo, OUTPUT_TTL);
            }}
          >
            <i className="fa fa-arrow-up" />
          </PushButton>
          <PushButton port={device.downPNo}
            onPush={() => {
              batchStore.setOutput(device.downPNo, OUTPUT_TTL);
            }}
          >
            <i className="fa fa-arrow-down" />
          </PushButton>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Boot);
